<div id="ht">
  <div id="main-cnt">
    <ion-header class="main-header block">
      <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
          <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
            <span class="breadcrumb" *ngIf="profile == 'clients'"
              >AMMINISTRATORE - ELENCO CONTRATTI</span
            >
          </div>
        </ion-buttons>
        <div slot="end" class="notification-div">

          <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
            <img [src]="sessionService?.user?.profileImg|s3Link" />

          </ion-avatar>
        </div>
        <app-add-bookmark slot="end"
                pageTitle="Contratti"
                url="/contracts"
        ></app-add-bookmark>
      </ion-toolbar>
      <br />

      <!-- edit da qui... -->

      <div class="flex-collapsible">
        <div class="flex-row header" (click)="showFilters = !showFilters">
          <div class="flex-1 text-center">
            <img
              class="svg-white vertical-middle xsmall"
              src="./assets/imgs/search.svg"
            />
            Ricerca
            <img
              class="svg-white vertical-middle xsmall"
              src="./assets/imgs/filter.svg"
            />
          </div>
        </div>

        <div class="panel" *ngIf="showFilters">
          <div style="text-align: center; padding: 1rem">
            <input
              [(ngModel)]="filters.name"
              name="name"
              class="text-input full-width block"
              placeholder="Ricerca per commerciale/cliente"
              type="search"
              (keyup)="filterContracts()"
            />

            <div class="flex-row" style="align-items: baseline">
              <div class="flex-1 text-left">Scadenza</div>
              <div class="flex-1 text-right">
                <input
                  [(ngModel)]="scadenza"
                  class="text-input"
                  type="date"
                  style="margin-left: 1rem"
                />
              </div>
            </div>

            <div class="flex-row" style="align-items: baseline">
              <div class="flex-1 text-left" style="flex: 8">Ordina per</div>
              <div class="flex-2 text-right">
                <ion-select
                  class="text-input"
                  style="flex: 2"
                  [(ngModel)]="filters.filterBy"
                  (ionChange)="filterContracts()"
                  [value]="filters.filterBy"
                >
                  <ion-select-option value="startDate"
                    >Data Inizio</ion-select-option
                  >
                  <ion-select-option value="endDate"
                    >Data Fine</ion-select-option
                  >
                  <ion-select-option value="amount">Capitale</ion-select-option>
                  <ion-select-option value="_lastChangedAt"
                    >Ultima Modifica</ion-select-option
                  >
                </ion-select>
              </div>
              <div class="flex-1 text-right">
                <img
                  (click)="changeSort()"
                  *ngIf="sortAscendent === sort.ASCENDING"
                  class="svg-white vertical-middle xsmall"
                  src="./assets/imgs/caret-down.svg"
                  style="transform: rotate(180deg)"
                />
                <img
                  (click)="changeSort()"
                  *ngIf="sortAscendent === sort.DESCENDING"
                  class="svg-white vertical-middle xsmall"
                  src="./assets/imgs/caret-down.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <h3 class="panel-title">Contracts</h3>
      <!-- ...a qui -->
    </ion-header>

    <ion-content class="main-content">
      <div class="scroller-container">
        <div class="content-scroller">
          <div class="content">
            <!-- edit da qui... -->

            <app-contracts-list #contractsListCmp></app-contracts-list>

            <!-- ...a qui -->
          </div>
        </div>
      </div>
    </ion-content>
  </div>
</div>

<!-- 

<ion-header>
  <ion-toolbar class="blues-nav">
    <ion-buttons slot="start" class="nav-content">      
      <div size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
          <span class="path1"></span> 
          <span class="path2"></span> 
        </span>
        <span class="breadcrumb" *ngIf="profile == 'clients'">AMMINISTRATORE - ELENCO CONTRATTI</span>
      </div>
    </ion-buttons>
    <div class="notification-div">      
      <div class="menu-user-icon" (click)="openPage('/my-profile')">

      </div>
    </div>
  </ion-toolbar>

  <div class="filter-div">

    <form class="filter-cnt">
      <ion-row class="filter-row">

        <ion-col size="10">
          <input [(ngModel)]="filters.name" name="name" class="search-input" placeholder="Ricerca per commerciale" type="search" (keyup)="filterContracts()">
        </ion-col> 

        <ion-col class="text-right" size="2">
          <button class="filters-button" (click)="showFilters = !showFilters"></button>
        </ion-col>
      </ion-row>
      
      <div [class.hidden]="!showFilters">
        
        <ion-row class="filter-row">
          <ion-col size="6">
            Scadenza
          </ion-col>
            
          <ion-col size="6" class="text-right">
            <input type="date">
          </ion-col>
        </ion-row>
      </div>
        
    </form>
  </div>
</ion-header>


<ion-content>
  
  <app-contracts-list #contractsListCmp ></app-contracts-list>

</ion-content> -->
